import React, { Fragment } from 'react'

import loader from '../../assets/images/loader.gif'

const Loader = () => {
   return (
      <Fragment>
         <img className='loader-image' src={loader} alt='loading...' />
      </Fragment>
   )
}

export default Loader
